import React, { useState, useEffect } from "react";
import axios from "axios";
import Head from "../components/Head";
import Foot from "../components/Foot";

const apiUrl = process.env.REACT_APP_API_URL;

function OurInfrastructure() {
  const [infrastructure, setInfrastructure] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInfrastructure = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/public/infrastructure`);
        if (response.data.success) {
          setInfrastructure(response.data.infrastructure);
        }
      } catch (err) {
        console.error("Error fetching infrastructure:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchInfrastructure();
  }, []);

  return (
    <>
      <Head />
      {/* Start Hero */}
      <section className="common-page-hero">
        <img
          src="assets/img/bg/common-bg.png"
          className="common-hero-bg ak-bg"
          alt="..."
        />
        <div className="common-hero-content">
          <div className="common-hero-info">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3" style={{ marginTop: 100 }}>
              <p className="ak-section-subtitle animation-title">Discover</p>
              <h2 className="ak-section-title animation-title">
                Our Infrastructure
              </h2>
            </div>
            <p className="back-btn">
              <a href="/">Home</a> / Discover / Our Infrastructure
            </p>
          </div>
          <a href="" className="phone-number">
            +91 90486 48777
          </a>
        </div>
      </section>
      {/* End Hero */}
      <div className="ak-height-60 ak-height-lg-50" />
      <section>
        <div className="container">
          {loading ? (
            <p>Loading...</p>
          ) : infrastructure.length === 0 ? (
            <p>No infrastructure images available yet.</p>
          ) : (
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
              {infrastructure.map((item) => (
                <div className="col" key={item.id}>
                  <div className="image-card h-100 bg-white shadow-lg rounded-lg overflow-hidden">
                    <div className="image-thumbnail cursor-pointer">
                      <img
                        src={`${apiUrl}/${item.imagepath}`}
                        alt={item.title}
                        className="w-full h-64 object-cover"
                      />
                    </div>
                    <div className="p-4">
                      <h5 className="text-lg font-semibold">{item.title}</h5>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
      <div className="ak-height-20 ak-height-lg-30" />
      <Foot />
    </>
  );
}

export default OurInfrastructure;
